import { useEffect, useRef } from 'react';

interface CameraPreviewProps {
  stream: MediaStream;
  onDismiss: () => void;
  onMinimize: () => void;
  isMinimized: boolean;
}

export function CameraPreview({ stream, onDismiss, onMinimize, isMinimized }: CameraPreviewProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  return (
    <div
      aria-label="Camera preview"
      className="fixed bottom-4 left-4 z-40 flex flex-col gap-1 rounded-lg bg-background/90 p-1 shadow-lg backdrop-blur"
    >
      {!isMinimized && (
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          width="160"
          className="max-w-[160px] max-h-[120px] rounded"
        />
      )}
      <div className="flex gap-1">
        <button
          onClick={onMinimize}
          aria-label="Minimize"
          className="rounded px-2 py-0.5 text-xs text-muted-foreground hover:bg-muted"
        >
          Minimize
        </button>
        <button
          onClick={onDismiss}
          aria-label="Dismiss"
          className="rounded px-2 py-0.5 text-xs text-muted-foreground hover:bg-muted"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
